import { render, staticRenderFns } from "./InquiryWrapper.vue?vue&type=template&id=ae7c9f78&"
import script from "./InquiryWrapper.vue?vue&type=script&lang=js&"
export * from "./InquiryWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports